module.exports = __webpack_public_path__ + "static/media/icon-integration.a48effd5.svg";